import { useGetAppEmaStatusSuspenseQuery } from '../../../__generated__/chirp/com/hubspot/applications/governance/rpc/ApplicationGovernanceAppAuthRpc.hooks';
import { useApp } from '../../contexts/AppContext';

export function useFetchEmaStatus() {
  const { appId } = useApp();
  const { data } = useGetAppEmaStatusSuspenseQuery({
    variables: {
      appId,
    },
  });

  return { data };
}
